import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import s from './UniversitySection.css';
import UniversityImageJpg from '../../../assets/images/university.jpg';
import UniversityImageWebp from '../../../assets/images/university.webp';
import Button from '../../../common/components/Button/Button';

export default function UniversitySectionPresentation({ isMobile }) {
  useStyles(s);
  return (
    <div className={s.internshipContainer}>
      <div>
        <picture>
          <source srcSet={UniversityImageWebp} type="image/webp" />
          <source srcSet={UniversityImageJpg} type="image/jpg" />
          <img src={UniversityImageJpg} className={s.universityImage} alt="university" width="90%" />
        </picture>
      </div>
      <section className={s.contentContainer}>
        <h2>ارتباط با دانشگاه</h2>
        <p className={s.description}>
          ما در تپسی، مشتاق ارتباط با دانشگاه‌هاییم چرا که فکر می‌کنیم این ارتباط، برای هر دو طرف ارزش‌آفرین و اثرگذار است. پس
          تلاش می‌کنیم با برگزاری کارگاه‌ها، جلسات انتقال تجربه و تورهای بازدید، فرصت آشنایی با صنعت و انتقال تجربه را برای
          دانشجویان علاقه‌مند فراهم کنیم. همچنین، مسیر حمایت از پایان‌نامه‌ها و پذیرش کارآموز نیز در تپسی فراهم است.
        </p>
        <a className={s.linkWrapper} href="https://tapsi.ir/contact">
          <Button theme="no-theme" fullWidth={isMobile}>
            ارتباط با تپسی
          </Button>
        </a>
      </section>
    </div>
  );
}

UniversitySectionPresentation.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};
